module.exports = __webpack_public_path__ + "img/bonanza-logo.b5f182c8.svg";